import React from 'react'
import { UserCard } from 'react-ui-cards'

/* images */

import { images } from '../Assets/Images/images'

const Location = () => {
  const cardsLocationItens = [
    // {
    //   title: 'Edificio Ceo',
    //   image: images.ceo,
    //   text: 'Av. João Cabral de Mello Neto, 850 - Bloco 3 (Sala 1601), Barra da Tijuca, Rio de Janeiro - RJ, CEP 22775-057, próximo ao Shopping Via Parque.',
    //   link: 'https://maps.app.goo.gl/ECSZSDTgna6uqZNU7'
    // },
    {
      title: 'Barra da Tijuca',
      image: images.dimension,
      text: 'Av. Abelardo Bueno, 1 - Loja 108, Barra da Tijuca, Rio de Janeiro - RJ, CEP 22790-703, em frente à Estação Centro-Metropolitano do BRT.',
      link: 'https://maps.app.goo.gl/m4S9xWJJQrxczFpi9'
    },
    {
      title: 'Nova América',
      image: images.novaAmerica,
      text: 'Av. Pastor Martin Luther King Jr., 126, Office 1000 - Sala 1009, Del Castilho, Rio de Janeiro - RJ, CEP 20765-000, ao lado do Shopping Nova América.',
      link: 'https://maps.app.goo.gl/GWGZy49nHpwy16WK7'
    },
    {
      title: 'Centro',
      image: images.uruguaiana,
      text: 'Av. Presidente Vargas, 435 - Sala 905, Centro, Rio de Janeiro - RJ, CEP 20071-904, próximo à estação Uruguaiana do metrô.',
      link: 'https://maps.app.goo.gl/Qi6k7wuWvrsFVsgn8'
    }
  ]

  return (
    <>
      <section id="location-section">
        <h3>Conheça nossas unidades</h3>
        <div className="location">
          {cardsLocationItens.map((item, i) => (
            <a href={item.link} target="_blank" rel="noreferrer">
              <UserCard
                key={i}
                float
                header={item.image}
                positionName={item.text}
                name={item.title}
              />
            </a>
          ))}
        </div>
      </section>
    </>
  )
}

export default Location
